// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RelatedInstitutions_related-entities__rq3Cm {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.RelatedInstitutions_related-entities--title__bgNr3 {
  font-weight: bold;
  font-size: 20px;
  color: var(--accent-color-dark);
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/InstitutionDetail/Components/RelatedInstitutions/RelatedInstitutions.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AACF;AACE;EACE,iBAAA;EACA,eAAA;EACA,+BAAA;AACJ","sourcesContent":[".related-entities {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  &--title {\n    font-weight: bold;\n    font-size: 20px;\n    color: var(--accent-color-dark);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"related-entities": `RelatedInstitutions_related-entities__rq3Cm`,
	"related-entities--title": `RelatedInstitutions_related-entities--title__bgNr3`
};
export default ___CSS_LOADER_EXPORT___;
